import { formattedYMDDate } from "../../../../../utils/dateUtils";
import { Card, CardBody, Col } from "reactstrap";
import BadgeDetails from "../../../../../CommonElements/Badge/BadgeDetails";
import {
  Amount,
  danger,
  Destination,
  Distance,
  infoColor,
  light,
  Mode,
  secondary,
  Source,
  Status,
  warningColor,
} from "../../../../../utils/Constant";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { ConveyanceDetail } from "../../../types";
import { useInViewPort } from "../../../../../hooks/useInViewport";
import IconComponent from "../../../../../CommonElements/IconComponent";

const ConveyanceCards = ({
  conveyanceInfo,
  conveyanceListLoading,
  openDialog,
}: {
  conveyanceInfo: ConveyanceDetail;
  conveyanceListLoading: boolean;
  openDialog: (conveyanceId: number) => void;
}) => {
  const { darkMode } = useAppSelector(({ layout }) => layout);
  const { observerRef, inView } = useInViewPort<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <Col xs="12" sm="6" key={conveyanceInfo.id}>
      <Card
        innerRef={observerRef}
        className={`notification-tabs mt-2 mb-2 ${
          inView ? "fadeInUp animate" : "opacity-0"
        }`}
      >
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <BadgeDetails
              color={light}
              className={`badget-light f-12 ${
                darkMode ? "text-white" : "text-dark"
              }`}
              text={formattedYMDDate(conveyanceInfo.date) ?? ""}
              loading={conveyanceListLoading}
            />
            <IconComponent
              className="icofont icofont-ui-delete text-danger f-16 pointer"
              onClick={() => openDialog(conveyanceInfo?.id)}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="w-50">
              <BadgeDetails
                color={warningColor}
                badgeHeading={Source}
                text={conveyanceInfo.source ?? ""}
                loading={conveyanceListLoading}
              />
            </div>
            <div className="w-50">
              <BadgeDetails
                color={secondary}
                badgeHeading={Destination}
                text={conveyanceInfo.destination ?? ""}
                loading={conveyanceListLoading}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="w-50">
              <BadgeDetails
                color={danger}
                badgeHeading={Mode}
                text={conveyanceInfo.mode ?? ""}
                loading={conveyanceListLoading}
              />
            </div>
            <div className="w-50">
              <BadgeDetails
                color={secondary}
                badgeHeading={Distance}
                text={conveyanceInfo.distance ?? ""}
                loading={conveyanceListLoading}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="w-50">
              <BadgeDetails
                color={warningColor}
                badgeHeading={Amount}
                text={conveyanceInfo.amount ?? ""}
                loading={conveyanceListLoading}
              />
            </div>
            <div className="w-50">
              <BadgeDetails
                color={infoColor}
                badgeHeading={Status}
                text={conveyanceInfo.status ?? ""}
                loading={conveyanceListLoading}
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ConveyanceCards;
